var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<ibox class=\"list-tags\"><header-ibox>{{::$ctrl.title || 'Tags'}}</header-ibox><toolbar><ibox-toolbar type=\"icon\" icon=\"edit\" ng-click=\"$ctrl.editTags()\"></ibox-toolbar></toolbar><div><tags-viewer ng-model=\"$ctrl.customer.tags\" tag-kinds=\"$ctrl.tagKinds\"></tags-viewer></div></ibox>";
var id1="customer-tags.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;